<!-- Header -->
<ion-header
  class="ion-no-border create-custom-message-header"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-desktop'
  "
  *ngIf="!mobileDateRangeMode"
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button data-cy="close-modal-btn" (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      >{{
        this.message
          ? ('i18n.profilePage.customMessages.titleEdit' | translate)
          : ('i18n.profilePage.customMessages.title' | translate)
      }}
    </ion-label>
  </ion-toolbar>
</ion-header>
<!-- Mobile Header -->
<ion-header
  class="ion-no-border ion-header-modal-mobile"
  *ngIf="mobileDateRangeMode"
>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button
        id="back-modal-btn"
        data-cy="back-modal-btn"
        text=""
        (click)="this.mobileDateRangeMode = false"
      >
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label>
      {{ 'i18n.orderStatusPage.dateRange' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content
  class="create-custom-message-content"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-desktop'
  "
  [scrollY]="true"
>
  <form [formGroup]="customMessageFormGroup" (ngSubmit)="saveMessage()">
    <ion-grid>
      <ion-row *ngIf="!mobileDateRangeMode">
        <!-- Left Column -->
        <ion-col
          [size]="
            platformService?.platformType ===
            platformService?.platformEnum.mobile
              ? 12
              : 6.5
          "
          class="create-custom-message-left-col"
        >
          <!-- Message -->
          <div class="message">
            <span data-cy="message-label" class="title-with-tooltip">
              {{ 'i18n.profilePage.customMessages.message' | translate }}
              <span
                class="message-form-required-text"
                data-cy="message-form-required-label"
              >
                {{ 'i18n.common.requiredInputIndicator' | translate }}
              </span>
            </span>
            <ion-item counter="true" lines="none">
              <ion-input
                id="message-input"
                #messageInput
                data-cy="message-input"
                formControlName="message"
                maxlength="90"
                placeholder="{{
                  'i18n.profilePage.customMessages.messageMax' | translate
                }}"
                type="text"
                (ionInput)="validateMaxChars($event)"
                [class.input-error]="
                  !customMessageFormGroup?.controls['message']?.valid &&
                  (customMessageFormGroup?.controls['message']?.touched ||
                    customMessageFormGroup?.controls['message']?.dirty) &&
                  customMessageFormGroup.controls['message'].errors['required']
                "
              >
              </ion-input>
            </ion-item>
            <div
              *ngIf="
                !customMessageFormGroup?.controls['message']?.valid &&
                customMessageFormGroup?.controls['message']?.dirty &&
                customMessageFormGroup?.controls['message']?.errors['required']
              "
              class="message-form-required-text-error-msg"
            ></div>
          </div>
          <!-- Customer List -->
          <div class="customer-list">
            <ng-container [ngTemplateOutlet]="file"></ng-container>
            <ng-template #file>
              <ion-card-title
                data-cy="customer-list-label"
                class="title-with-tooltip"
              >
                {{ 'i18n.profilePage.customMessages.customerList' | translate }}
                <span
                  class="message-form-required-text"
                  data-cy="customer-list-form-required-label"
                >
                  {{ 'i18n.common.requiredInputIndicator' | translate }}
                </span>
                <ion-icon
                  id="hover-file-trigger"
                  data-cy="file-information-icon"
                  name="information-circle-outline"
                  (mouseenter)="showAcceptedFileTypesPopover($event)"
                  (mouseleave)="shouldCloseAcceptedFileTypesPopover($event)"
                ></ion-icon>
              </ion-card-title>
              <div
                data-cy="file-card"
                [ngClass]="
                  this.fileInvalidType ||
                  this.fileInvalidData ||
                  this.fileMissingHeader ||
                  this.fileErrorInRows?.length > 0
                    ? 'border-error'
                    : ''
                "
                class="file-card"
              >
                <!-- Add File -->
                <div
                  *ngIf="!fileAttached; else viewFile"
                  data-cy="add-file-button"
                  (click)="uploadFile()"
                  class="add-file"
                >
                  <ion-icon
                    data-cy="add-file-icon"
                    name="reader-outline"
                  ></ion-icon>
                  <ion-label class="add-file-text" data-cy="add-file-text">
                    {{ 'i18n.requestCredit.uploadAFile' | translate }}
                  </ion-label>
                </div>
                <!-- View File -->
                <ng-template #viewFile>
                  <div class="view-file">
                    <div class="file-info">
                      <ion-icon
                        data-cy="view-file-icon"
                        class="icon-file"
                        name="reader"
                      ></ion-icon>
                      <ion-label data-cy="view-file-text">
                        {{ this.fileName }}
                      </ion-label>
                    </div>
                    <div class="delete-change-file">
                      <a data-cy="delete-file-button" (click)="deleteFile()">
                        {{ 'i18n.common.delete' | translate }}
                      </a>
                      <span>|</span>
                      <a data-cy="change-file-button" (click)="uploadFile()">
                        {{ 'i18n.common.change' | translate }}
                      </a>
                    </div>
                  </div>
                </ng-template>
              </div>
            </ng-template>
            <div
              *ngIf="this.fileInvalidType"
              class="message-form-required-text-error-msg fileErrors"
            >
              <span>{{
                'i18n.profilePage.customMessages.fileTypeError' | translate
              }}</span>
            </div>
            <div
              *ngIf="this.fileInvalidData || this.fileMissingHeader"
              class="message-form-required-text-error-msg fileErrors"
            >
              <span>{{
                'i18n.profilePage.customMessages.fileInvalidData' | translate
              }}</span>
            </div>
            <div
              *ngIf="this.fileErrorInRows?.length > 0"
              class="message-form-required-text-error-msg fileErrors"
            >
              <span>{{
                (
                  'i18n.profilePage.customMessages.fileRowError' | translate
                ).replace('rowList', this.fileErrorInRows.toString())
              }}</span>
            </div>
            <div class="download-template">
              <a (click)="downloadTemplate()">{{
                'i18n.profilePage.customMessages.templateDownload' | translate
              }}</a>
            </div>
          </div>
          <!-- CTA -->
          <div class="cta">
            <span data-cy="cta-label" class="title-with-tooltip">
              {{ 'i18n.profilePage.customMessages.ctaURL' | translate }}
            </span>
            <ion-input
              id="cta-input"
              data-cy="cta-input"
              formControlName="cta"
              placeholder="{{
                'i18n.profilePage.customMessages.enterOptionalCTA' | translate
              }}"
              type="url"
              [class.input-error]="
                !customMessageFormGroup?.controls['cta']?.valid &&
                (customMessageFormGroup?.controls['cta']?.touched ||
                  customMessageFormGroup?.controls['cta']?.dirty)
              "
            >
            </ion-input>
            <div
              *ngIf="
                !customMessageFormGroup?.controls['cta']?.valid &&
                customMessageFormGroup?.controls['cta']?.dirty
              "
              class="message-form-required-text-error-msg"
            >
              <span>{{
                'i18n.profilePage.customMessages.ctaError' | translate
              }}</span>
            </div>
          </div>
          <!-- Mobile Date Range -->
          <div
            class="mobile-date-range"
            *ngIf="
              platformService?.platformType ===
              platformService?.platformEnum.mobile
            "
            (click)="showDateRengeMobile()"
          >
            <span data-cy="cta-label" class="title-with-tooltip">
              {{ 'i18n.orderStatusPage.dateRange' | translate }}
            </span>
            <ion-input
              id="mobile-date-range-input"
              data-cy="mobile-date-range-input"
              placeholder="{{
                'i18n.orderStatusPage.datePlaceholder' | translate
              }} - {{ 'i18n.orderStatusPage.datePlaceholder' | translate }}"
              type="text"
              [value]="this.mobileDateRangeValue"
            >
            </ion-input>
            <ion-icon
              class="mobile-date-range-edit"
              name="chevron-forward-outline"
            ></ion-icon>
          </div>
        </ion-col>
        <!-- Right Column -->
        <ion-col
          offset="0.5"
          size="5"
          *ngIf="
            platformService?.platformType !==
            platformService?.platformEnum.mobile
          "
          class="create-custom-message-right-col"
        >
          <!-- Delivery Date -->
          <div class="delivery-date">
            <div class="delivery-date-info">
              <ion-icon name="calendar-outline"></ion-icon>
              <span class="date-range">
                {{ 'i18n.orderStatusPage.dateRange' | translate }}:&nbsp;
              </span>
              <div class="date-container">
                <span *ngIf="selectedRangeValue?.start" class="date">
                  {{ selectedRangeValue.start.format('M/D/YYYY') }}
                </span>
                <span
                  *ngIf="!selectedRangeValue?.start"
                  class="date-placeholder"
                >
                  {{ 'i18n.orderStatusPage.datePlaceholder' | translate }}
                </span>
                <span class="date-placeholder">-</span>
                <span *ngIf="selectedRangeValue?.end" class="date">
                  {{ selectedRangeValue?.end.format('M/D/YYYY') }}
                </span>
                <span *ngIf="!selectedRangeValue?.end" class="date-placeholder">
                  {{ 'i18n.orderStatusPage.datePlaceholder' | translate }}
                </span>
              </div>
            </div>
            <mat-card>
              <mat-calendar
                #calendar
                [selected]="selectedRangeValue"
                [minDate]="today"
                (selectedChange)="selectedDateRangeChange($event)"
              >
              </mat-calendar>
            </mat-card>
          </div>
          <!-- Reset -->
          <div class="reset">
            <ion-button
              data-cy="home-custom-message-banner-btn"
              class="usf-outline-orange-button reset-button"
              (click)="resetForm()"
            >
              {{ 'i18n.common.reset' | translate }}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
      <!-- Mobile Date Range Selector -->
      <ion-row *ngIf="mobileDateRangeMode">
        <ion-col class="create-custom-message-right-col">
          <!-- Delivery Date -->
          <div class="delivery-date">
            <div class="delivery-date-info">
              <ion-icon name="calendar-outline"></ion-icon>
              <span class="date-range">
                {{ 'i18n.orderStatusPage.dateRange' | translate }}:&nbsp;
              </span>
              <div class="date-container">
                <span *ngIf="selectedRangeValue?.start" class="date">
                  {{ selectedRangeValue.start.format('M/D/YYYY') }}
                </span>
                <span
                  *ngIf="!selectedRangeValue?.start"
                  class="date-placeholder"
                >
                  {{ 'i18n.orderStatusPage.datePlaceholder' | translate }}
                </span>
                <span class="date-placeholder">-</span>
                <span *ngIf="selectedRangeValue?.end" class="date">
                  {{ selectedRangeValue?.end.format('M/D/YYYY') }}
                </span>
                <span *ngIf="!selectedRangeValue?.end" class="date-placeholder">
                  {{ 'i18n.orderStatusPage.datePlaceholder' | translate }}
                </span>
              </div>
            </div>
            <mat-card>
              <mat-calendar
                [selected]="selectedRangeValue"
                [minDate]="today"
                (selectedChange)="selectedDateRangeChange($event)"
              >
              </mat-calendar>
            </mat-card>
          </div>
          <!-- Reset -->
          <div class="reset">
            <ion-button
              data-cy="home-custom-message-banner-btn"
              class="usf-outline-orange-button reset-button"
              (click)="resetForm()"
            >
              {{ 'i18n.common.reset' | translate }}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
<!-- Footer -->
<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="clear-all-modal-btn"
        data-cy="clear-all-modal-btn"
        [ngClass]="
          platformService?.platformType !== platformService?.platformEnum.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismissModal()"
        translate
      >
        {{ 'i18n.common.cancel' }}
      </ion-button>
      <ion-button
        id="apply-modal-btn"
        data-cy="apply-modal-btn"
        [ngClass]="
          platformService?.platformType !== platformService?.platformEnum.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="saveMessage()"
        translate
        [disabled]="
          customMessageFormGroup?.invalid ||
          (this.message && !customMessageFormGroup?.dirty)
        "
      >
        {{
          this.message
            ? ('i18n.common.update' | translate)
            : ('i18n.common.create' | translate)
        }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
